import { useAuthStore } from "..";
import { showErrorToast } from "../components/ToastContainer";

const useLogin = (): (login: string, password: string, rememberMe: boolean) => Promise<void> => {
    const authStore = useAuthStore();

    return async (login: string, password: string, rememberMe: boolean): Promise<void> => {
        try {
            await authStore.login(login, password, rememberMe);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLogin;